module.exports = __webpack_public_path__ + "img/宝中.298c9b5e.png";